<ul class="legend">
  <span class="legend-label" style="margin-right: 15px;">Legenda:</span>
    <li *ngFor="let entry of legendEntries">
      <span class="legend-color" [style.background-color]="entry.color"></span>
      <span class="legend-label">{{ entry.label }}</span>
    </li>
</ul>

